
import {Button, Card, Divider, Input} from "antd";
import {Label} from "@/components/ui/label";
import {URLS} from "@/lib/urls";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useRef} from "react";
import {toast} from "react-toastify";
import {saveTokens} from "@/lib/services/tokenService";
import {useApiAuthLogin, useApiAuthOtp} from "@/api/auth";
import {formatMobileNumber} from "@/lib/utils/number";
import AuthCardHeaderSection from "@/pages/auth/_section/AuthCardHeaderSection";
import {AuthFooterLinkNewMobileSection} from "@/pages/auth/_section/AuthFooterLinkNewMobileSection";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

export default function StateLoginSection({changeMyState, myMobile, setMyData}) {


    let passwordRef = useRef(null);
    const navigate = useNavigate();
    const {mutate: AuthLogin, isPending} = useApiAuthLogin()
    const {mutate: AuthSendOtp, isPendingOtp} = useApiAuthOtp()


    useEffect(() => {
        passwordRef.current.focus();
    })

    function submitForm() {

        if (!myMobile) {
            toast.error('لطفا تلفن همراه خود را وارد کنید')
            changeMyState('check')
            return;
        }

        if (!passwordRef.current.input.value) {
            toast.error('لطفا کلمه عبور خود را وارد کنید')
            passwordRef.current.focus()
            return;
        }

        AuthLogin({
            mobile: formatMobileNumber(myMobile),
            password: passwordRef.current.input.value
        }, {
            onSuccess: (data) => {
                if (data.data?.data?.access_token) {
                    saveTokens({
                        accessToken: data.data?.data?.access_token,
                        refreshToken: data.data?.data?.refresh_token,
                        rememberMe: true
                    });
                    navigate(URLS.gateway.selector, {replace: true})
                    return;
                }

                if (data?.response_code === 'TWO_FACTOR_AUTH' || data?.response_code === 'TWO_FACTOR_AUTH_ADMIN') {
                    AuthSendOtp({
                        mobile: formatMobileNumber(myMobile),
                    }, {
                        onSuccess: (d) => {

                            setMyData({
                                otpToken: d?.data?.data?.otp_token,
                                callFrom: 'twoFactor'
                            })

                            changeMyState('otp')
                        }, onError: (e) => {
                            ApiHandleErrorMessage(e);
                        }
                    })

                    return;
                }


                toast.error('خطایی پیش آمده لطفا مجددا تلاش کنید');

            }, onError: (error) => {
                ApiHandleErrorMessage(error);
            }
        })
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            submitForm()
        }
    };


    return (
        <Card>
            <AuthCardHeaderSection title={'ورود به حساب کاربری'} description={'لطفا کلمه عبور خود را وارد کنید'}/>

            <div className={'mt-4'}>

                <div className="flex flex-col gap-6">

                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="password">کلمه عبور</Label>

                        </div>
                        <Input.Password
                            iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                            placeholder="رمز عبور خود را وارد کنید"
                            ref={passwordRef}
                            disabled={isPending}
                            autoComplete="off"
                            id="password" type="password" required

                            onKeyDown={handleKeyDown}
                        />


                    </div>
                    <Button
                        htmlType={'submit'}
                        loading={isPending}
                        onClick={() => submitForm()}
                        type="primary" className="w-full">
                        ورود
                    </Button>

                </div>
                <Divider orientation="vertical"/>
                <div className="mt-4 text-center text-sm">
                    رمز عبور خود را فراموش کرده اید؟
                    <Button type={'link'} className={''} onClick={() => changeMyState('recovery')}>

                        بازیابی رمز ورود

                    </Button>
                </div>
                <AuthFooterLinkNewMobileSection myMobile={myMobile} changeMyState={changeMyState}/>


            </div>
        </Card>

    );
}
